<template>
  <div>
    <DeleteModal
      class="display-none-print"
      modal-id="modal-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('office.vital-sign')}`
          : `${$t('common.edit')} ${$t('office.vital-sign')}`
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('office.vital-signs-types')"
              label-for="status"
            >
              <AutoComplete
                v-model="EditForm.vital_sign_type"
                placeholder="Select vital sign type"
                :serializer="(val) => val"
                endpoint="vital-sign-types"
                text-title="name"
                @input="setVitalSignTypeValue"
              />
              <div
                v-if="vital_sign_type_value.max || vital_sign_type_value.min"
                class="d-flex justify-content-between"
              >
                <span>({{ $t("common.minValue") }} -
                  {{ vital_sign_type_value.min }})</span>
                <span>
                  ({{ $t("common.maxValue") }} -
                  {{ vital_sign_type_value.max }})</span>
              </div>
            </b-form-group>
          </b-col>

          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('common.value')"
              label-for="value"
            >
              <b-form-input
                v-model="EditForm.value"
                :placeholder="$t('common.value')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('common.date')"
              label-for="date"
            >
              <datetime
                v-model="EditForm.date"
                input-class="form-control"
                type="datetime"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('office.vital-signs')">
      <div>
        <b-row class="display-none-print">
          <b-col
            cols="12"
            md="12"
          >
            <h2>{{ $t("common.filter") }} {{ $t("office.vital-signs") }}</h2>
            <br>
          </b-col>

          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('office.vital-signs-types')"
              label-for="Name"
            >
              <AutoComplete
                v-model="typeFilter"
                placeholder="Select vital sign type"
                :serializer="(val) => val.name"
                endpoint="vital-sign-types"
                text-title="name"
                @input="setVitalSignTypeValue"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('common.date')"
              label-for="Name"
            >
              <datepicker
                v-model="dateFilter"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row class="display-none-print">
          <b-col
            cols="12"
            md="12"
          >
            <br>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button
              variant="primary"
              @click="getVitalSigns()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div
          class="d-flex justify-content-between mt-4 mb-2 display-none-print"
        >
          <h2 class="display-none-print">
            {{ $t("common.table") }} {{ $t("office.vital-signs") }} :{{
              $route.params.name
            }}
          </h2>

          <div class="d-flex">
            <b-button
              variant="primary"
              class="display-none-print mx-1"
              :disabled="!is_active"
              @click="show(EditForm, 'create')"
            >
              {{ $t("common.create") }} {{ $t("office.vital-sign") }}
            </b-button>
            <!-- <PrintVitalSignVue
              :refresh="refresh"
              :url="fetchUrl"
              :data="printData"
            /> -->
          </div>
        </div>
        <b-table
          v-if="!loading"
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative display-none-print"
        >
          <!-- Column: Actions -->
          <template #cell(value)="data">
            <span
              v-if="data.item.result_as_to_normal_range.is_normal"
              class="px-1"
            >{{ data.item.value }}</span>
            <span
              v-else
              class="px-1"
              style="color: red"
            >{{
              data.item.value
            }}</span>
            <!-- Check if the message contains "Below" -->
            <feather-icon
              v-if="
                data.item.result_as_to_normal_range.message.includes('Below')
              "
              icon="ArrowDownIcon"
              size="18"
            />

            <!-- Check if the message contains "Above" -->
            <feather-icon
              v-else-if="
                data.item.result_as_to_normal_range.message.includes('Above')
              "
              icon="ArrowUpIcon"
              size="18"
            />
            <span class="px-1">{{
              data.item.result_as_to_normal_range.message
            }}</span>
          </template>

          <template #cell(normal_value)="data">
            <span>{{ data.item.vital_sign_type_data.min_normal_value }} -
              {{ data.item.vital_sign_type_data.max_normal_value }}</span>
          </template>
          <template #cell(actions)="data">
            <ActionsButtons
              delete-perm="delete-patient-doctor-note"
              edit-perm="update-patient-doctor-note"
              :disabled="!is_active"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            />
          </template>
        </b-table>

        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2 display-none-print">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span
                class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("reception.doctor-notes") }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getVitalSigns()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- <VitalSignsCharts :refresh="refresh" :url="fetchUrl" /> -->
    </b-card>

    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <DeleteModal
      class="display-none-print"
      modal-id="modal-delete-drug-prescription"
      @deleteToggle="deleteDrugPrescription"
    />
    <b-modal
      id="modal-drug-prescription"
      :no-close-on-backdrop="true"
      centered
      size="lg"
      :title="$t('office.patient-drug-prescription')"
      @ok="submitDrugPrescription()"
    >
      <!-- Custom Footer -->
      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="drugPrescriptionLoading"
          block
          @click="submitDrugPrescription"
        >
          <span v-if="!drugPrescriptionLoading">{{ $t("common.submit") }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.source_of_drug')">
              <v-select
                v-model="drugPrescriptionForm.source_of_drug"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Hospital', value: 'hospital' },
                  { label: 'Pharmacy', value: 'pharmacy' },
                  { label: 'External', value: 'external' },
                ]"
                :reduce="(option) => option.value"
                :placeholder="$t('office.source_of_drug')"
                @input="handleSourceChange"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="
              drugPrescriptionForm.source_of_drug !== 'external' &&
                drugPrescriptionForm.source_of_drug === 'pharmacy'
            "
            md="6"
          >
            <AutoComplete
              v-model="drug_scientific_name_id"
              :label="$t('common.drug_scientific_name')"
              :placeholder="$t('common.drug_scientific_name')"
              :serializer="(val) => val.id"
              endpoint="drugScientificName"
              text-title="name"
            />
            <AutoComplete
              v-model="drugPrescriptionForm.item_id"
              :disabled="!drugPrescriptionForm.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :other-query="`filter[type]=${drugPrescriptionForm.source_of_drug}&filter[drug_scientific_name_id]=${drug_scientific_name_id}`"
            />
          </b-col>
          <b-col
            v-if="
              drugPrescriptionForm.source_of_drug !== 'external' &&
                drugPrescriptionForm.source_of_drug === 'hospital'
            "
            md="6"
          >
            <AutoComplete
              v-model="drugPrescriptionForm.item_id"
              :disabled="!drugPrescriptionForm.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :other-query="`filter[type]=${drugPrescriptionForm.source_of_drug}`"
            />
          </b-col>
          <b-col
            v-if="drugPrescriptionForm.source_of_drug === 'external'"
            md="6"
          >
            <b-form-group :label="$t('office.item_name_external')">
              <b-form-input
                v-model="drugPrescriptionForm.item_name"
                :placeholder="$t('office.item_name_external')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.number_of_doses')">
              <b-form-input
                v-model="drugPrescriptionForm.number_of_doses"
                type="number"
                :placeholder="$t('office.number_of_doses')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('office.duration_between_doses')">
              <b-form-input
                v-model="drugPrescriptionForm.duration_between_doses"
                :placeholder="$t('office.duration_between_doses')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.type')">
              <b-form-input
                v-model="drugPrescriptionForm.type"
                :placeholder="$t('office.type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('office.dose')">
              <b-form-input
                v-model="drugPrescriptionForm.dose"
                :placeholder="$t('office.dose')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('office.start_time')">
              <datetime
                v-model="drugPrescriptionForm.start_time"
                input-class="form-control"
                type="datetime"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('office.description')">
              <b-form-textarea
                v-model="drugPrescriptionForm.description"
                :placeholder="$t('office.description')"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Add new modal for editing drug table entry -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <b-modal
      id="modal-add-drug-to-patient"
      centered
      :title="$t('emergency.add-drug-to-patient')"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          :disabled="addDrugLoading"
          block
          @click="submitAddDrugToPatient"
        >
          <span v-if="!addDrugLoading">{{ $t("common.submit") }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>

      <b-card-text>
        <b-row>
          <!-- Department field - only shown for hospital source -->
          <b-col
            v-if="selectedDrug && selectedDrug.source_of_drug === 'hospital'"
            md="12"
          >
            <AutoComplete
              v-model="addDrugForm.department_id"
              :label="$t('office.department')"
              :placeholder="$t('office.department')"
              :serializer="(val) => val.id"
              endpoint="departments"
              text-title="name"
              :required="true"
              @input="handleDepartmentChange"
            />
          </b-col>

          <!-- Item field -->
          <!-- <b-col md="12">
            <AutoComplete
              v-if="selectedDrug && selectedDrug.source_of_drug !== 'external'"
              :label="$t('emergency.item')"
              :placeholder="$t('emergency.item')"
              v-model="addDrugForm.item_id"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :otherQuery="departmentQuery"
            />

            <b-form-group v-else :label="$t('emergency.item_name_external')">
              <b-form-input
                v-model="addDrugForm.item_name"
                :placeholder="$t('emergency.item_name_external')"
              />
            </b-form-group>
          </b-col> -->

          <!-- Quantity field -->
          <b-col md="12">
            <b-form-group :label="$t('emergency.quantity')">
              <b-form-input
                v-model="addDrugForm.quantity"
                type="number"
                :placeholder="$t('emergency.quantity')"
                min="1"
              />
            </b-form-group>
          </b-col>

          <!-- Time field -->
          <b-col md="12">
            <b-form-group :label="$t('emergency.time')">
              <datetime
                v-model="addDrugForm.time"
                input-class="form-control"
                type="datetime"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-card :title="$t('office.patient-drug-prescription')">
      <!-- Data Table  -->
      <div class="d-flex justify-content-between mt-4 mb-2 display-none-print">
        <h2 class="display-none-print">
          {{ $t("common.table") }}
          {{ $t("office.patient-drug-prescription") }} :{{ $route.params.name }}
        </h2>

        <div class="d-flex">
          <b-button
            variant="primary"
            class="display-none-print mx-1"
            :disabled="!is_active"
            @click="showDrugPrescription(EditForm, 'create')"
          >
            {{ $t("common.create") }}
            {{ $t("office.patient-drug-prescription") }}
          </b-button>
          <!-- <PrintVitalSignVue
            :refresh="refresh"
            :url="fetchUrl"
            :data="printData"
          /> -->
        </div>
      </div>
      <b-table
        v-if="!drugPrescriptionLoading"
        :items="dataDrugPrescription"
        responsive
        :fields="tableColumnsDrugPrescription"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative display-none-print"
      >
        <template #cell(actions)="data">
          <ActionsButtons
            delete-perm="delete-patientCardPrescription"
            edit-perm="update-patientCardPrescription"
            :disabled="!is_active"
            @editToggle="showDrugPrescription(data.item)"
            @deleteToggle="deleteModelDrugPrescription(data.item)"
          />
        </template>
        <template #cell(item_drug_name)="data">
          <span v-if="data.item.item != null">
            <span
              v-if="data.item.source_of_drug === 'pharmacy'"
              style="text-transform: uppercase; color: #000"
            >({{ data.item.drug_scientific_name.name }})</span>
            {{ getNestedProperty(data.item, "item.name") }}
          </span>
          <span v-else>
            {{ data.item.item_name }}
            <span class="text-danger">
              ({{ $t("common.item_is_external") }})
            </span>
          </span>
        </template>
        <template #cell(add_drug_to_patient)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mb-75 mx-1"
            :disabled="!is_active"
            @click="showAddDrugModal(data.item)"
          >
            {{ $t("emergency.add-drug-to-patient") }}
          </b-button>
        </template>
      </b-table>

      <template v-if="drugPrescriptionLoading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2 display-none-print">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span
              class="text-muted"
            >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              {{ $t("reception.doctor-notes") }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getVitalSigns()"
          >
            <b-pagination
              v-model="pageDrugPrescription"
              :total-rows="dataCountDrugPrescription"
              :per-page="takeDrugPrescription"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Patient Drug Table -->
    <!-- Add new modal for editing drug table entry -->
    <b-modal
      id="modal-edit-drug-table-entry"
      centered
      :title="$t('emergency.edit-drug-entry')"
      @ok="submitEditDrugTableEntry"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          :disabled="editDrugTableLoading"
          block
          @click="submitEditDrugTableEntry"
        >
          <span v-if="!editDrugTableLoading">{{ $t("common.submit") }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>

      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('emergency.quantity')">
              <b-form-input
                v-model="editDrugTableForm.quantity"
                type="number"
                :placeholder="$t('emergency.quantity')"
                min="1"
                :disabled="true"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('emergency.time')">
              <datetime
                v-model="editDrugTableForm.time"
                input-class="form-control"
                type="datetime"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Add delete confirmation modal -->
    <DeleteModal
      class="display-none-print"
      modal-id="modal-delete-drug-table-entry"
      @deleteToggle="submitDeleteDrugTableEntry"
    />

    <!-- Bulk Drug Addition Modal -->
    <b-modal
      id="modal-bulk-drug"
      :no-close-on-backdrop="true"
      centered
      size="xl"
      :title="$t('office.bulk-add-drugs') || 'إضافة أدوية متعددة'"
      @ok="submitBulkDrugs"
    >
      <template #modal-footer="{}">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="closeBulkDrugModal"
        >
          {{ $t("common.cancel") }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="bulkDrugLoading"
          @click="submitBulkDrugs"
        >
          <span v-if="!bulkDrugLoading">{{ $t("common.submit") }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>
      <b-card-text>
        <div
          v-for="(drug, index) in bulkDrugs"
          :key="index"
          class="mb-3 p-3 border rounded"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="mb-0">
              {{ $t("office.drug") }} {{ index + 1 }}
            </h6>
            <b-button
              v-if="bulkDrugs.length > 1"
              variant="outline-danger"
              size="sm"
              @click="removeBulkDrug(index)"
            >
              <feather-icon
                icon="XIcon"
                size="14"
              />
            </b-button>
          </div>
          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('office.source_of_drug')">
                <v-select
                  v-model="drug.source_of_drug"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[
                    { label: 'Hospital', value: 'hospital' },
                    { label: 'Pharmacy', value: 'pharmacy' },
                    { label: 'External', value: 'external' },
                  ]"
                  :reduce="(option) => option.value"
                  :placeholder="$t('office.source_of_drug')"
                  @input="handleBulkSourceChange(index, $event)"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="drug.source_of_drug && drug.source_of_drug !== 'external'"
              md="3"
            >
              <b-form-group :label="$t('office.item_name')">
                <AutoComplete
                  v-model="drug.item_id"
                  :placeholder="$t('office.item_name')"
                  :serializer="(val) => val.id"
                  endpoint="item"
                  text-title="name"
                  :other-query="`filter[type]=${drug.source_of_drug}`"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="drug.source_of_drug === 'external'"
              md="3"
            >
              <b-form-group :label="$t('office.item_name_external')">
                <b-form-input
                  v-model="drug.item_name"
                  :placeholder="$t('office.item_name_external')"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('office.number_of_doses')">
                <b-form-input
                  v-model.number="drug.number_of_doses"
                  type="number"
                  :placeholder="$t('office.number_of_doses')"
                  min="1"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('office.duration_between_doses')">
                <b-form-input
                  v-model.number="drug.duration_between_doses"
                  type="number"
                  :placeholder="$t('office.duration_between_doses')"
                  min="1"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-button
          variant="outline-primary"
          size="sm"
          @click="addBulkDrugRow"
        >
          <feather-icon
            icon="PlusIcon"
            size="14"
          />
          {{ $t("office.add-another-drug") || "إضافة دواء آخر" }}
        </b-button>
      </b-card-text>
    </b-modal>

    <b-card :title="$t('emergency.patient-drug-table')">
      <div class="d-flex justify-content-end mb-3">
        <b-button
          variant="primary"
          :disabled="!is_active"
          @click="showBulkDrugModal"
        >
          <feather-icon
            icon="PlusIcon"
            size="14"
          />
          {{ $t("office.bulk-add-drugs") || "إضافة أدوية متعددة" }}
        </b-button>
      </div>

      <!-- Bulk Drug Time Table -->
      <div
        v-if="dataDrugPrescription.length > 0"
        class="bulk-drug-table-container"
      >
        <table class="bulk-drug-table">
          <tbody>
            <tr
              v-for="drug in dataDrugPrescription"
              :key="drug.id"
              class="drug-row"
            >
              <!-- Drug Name Column -->
              <td class="drug-name-cell">
                <div class="drug-name-content">
                  <strong>{{
                    drug.item
                      ? getNestedProperty(drug, "item.name")
                      : drug.item_name
                  }}</strong>
                  <span
                    v-if="drug.source_of_drug === 'pharmacy' && drug.drug_scientific_name"
                    class="text-muted ml-2"
                  >
                    ({{ drug.drug_scientific_name.name }})
                  </span>
                  <span
                    v-if="!drug.item"
                    class="text-danger ml-1"
                  >
                    ({{ $t("common.item_is_external") }})
                  </span>
                </div>
              </td>
              <!-- Dose Time Columns -->
              <td
                v-for="(doseTime, index) in getDoseTimes(drug)"
                :key="`${drug.id}-dose-${index}`"
                class="dose-time-cell"
                :class="{
                  'dose-taken': isDoseTaken(drug, doseTime),
                  'dose-clickable': !isDoseTaken(drug, doseTime) && is_active,
                }"
                @click="markDoseAsTaken(drug, doseTime)"
              >
                <div class="dose-time-content">
                  <span v-if="isDoseTaken(drug, doseTime)">
                    <feather-icon
                      icon="CheckCircleIcon"
                      size="16"
                      class="text-success"
                    />
                    <span class="text-success text-decoration-line-through">
                      {{ formatTime(doseTime) }}
                    </span>
                  </span>
                  <span v-else>
                    {{ formatTime(doseTime) }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-else
        class="text-center py-5"
      >
        <p class="text-muted">
          {{ $t("office.no-drugs-prescribed") || "لا توجد أدوية موصوفة" }}
        </p>
      </div>
    </b-card>
    <b-card>
      <div class="d-flex justify-content-center">
        <ShoAndNursing
          :data="dataDrugPrescription"
          :new-vital-sign-data="newVitalSignData"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BCardText,
  BCardTitle,
  BIcon,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import permissionChecker from '@/mixins/permissionChecker'
import ActionsButtons from '@/components/common/ActionsButtons.vue'
import DeleteModal from '@/components/modals/DeleteModal.vue'
import { Datetime } from 'vue-datetime'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import 'vue-datetime/dist/vue-datetime.css'
import AutoComplete from '@/components/common/AutoComplete.vue'
import ShoAndNursing from '@/components/printables/ShoAndNursing.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormTextarea,
    Datetime,
    ActionsButtons,
    DeleteModal,
    Datepicker,
    vSelect,
    AutoComplete,
    BIcon,
    ShoAndNursing,
    BCardText,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 100,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      pationtData: {},
      data: [],
      date: new Date(Date.now()).toISOString(),
      EditForm: {
        date: '',
        value: '',
        vital_sign_type: '',
        patient_card_id: this.$route.params.id,
        _method: 'PUT',
      },
      vital_sign_type_value: {
        min: 0,
        max: 0,
      },
      createMode: false,
      errorForm: {
        date: '',
        value: '',
        vital_sign_type: '',
        patient_card_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      chartData: {
        labels: [], // Will be filled with dates
        datasets: [],
      },
      tableColumns: [
        {
          key: 'vital_sign_type',
          label: this.$t('office.vital_sign_type'),
          sortable: true,
        },
        {
          key: 'normal_value',
          label: this.$t('office.normal_value'),
          sortable: true,
        },
        { key: 'value', label: this.$t('common.value'), sortable: true },
        { key: 'date', label: this.$t('common.date'), sortable: true },

        { key: 'Actions', label: this.$t('common.actions') },
      ],

      // Drug Prescription
      tableColumnsDrugPrescription: [
        {
          key: 'item_drug_name',
          label: this.$t('office.item_name'),
          sortable: true,
        },
        // {
        //   key: "item_name",
        //   label: this.$t("office.item_name_external"),
        //   sortable: true,
        // },
        {
          key: 'number_of_doses',
          label: this.$t('office.number_of_doses'),
          sortable: true,
        },
        {
          key: 'duration_between_doses',
          label: this.$t('office.duration_between_doses'),
          sortable: true,
        },
        {
          key: 'source_of_drug',
          label: this.$t('office.source_of_drug'),
          sortable: true,
        },
        { key: 'type', label: this.$t('office.type'), sortable: true },
        { key: 'dose', label: this.$t('office.dose'), sortable: true },
        {
          key: 'start_time',
          label: this.$t('office.start_time'),
          sortable: true,
        },
        {
          key: 'description',
          label: this.$t('office.description'),
          sortable: true,
        },
        {
          key: 'add_drug_to_patient',
          label: this.$t('emergency.add-drug-to-patient'),
        },

        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      printData: false,
      refresh: false,
      fetchUrl: '',
      typeFilter: null,
      dataCountDrugPrescription: 0,
      pageDrugPrescription: 1,
      takeDrugPrescription: 100,
      dataDrugPrescription: [],
      patientCardId: this.$route.params.id,
      dateFilter: null,
      allItems: [],
      drugPrescriptionLoading: false,
      drugPrescriptionForm: {
        item_id: null,
        item_name: '',
        number_of_doses: '',
        duration_between_doses: '',
        source_of_drug: '',
        type: '',
        dose: '',
        start_time: new Date().toISOString(),
        description: '',
      },
      errorDrugPrescriptionForm: {
        item_id: null,
        item_name: '',
        number_of_doses: '',
        duration_between_doses: '',
        source_of_drug: '',
        type: '',
        dose: '',
        start_time: new Date().toISOString(),
        description: '',
      },
      addDrugForm: {
        department_id: null,
        item_id: null,
        quantity: '',
        time: null,
      },
      selectedDrug: null,
      departmentQuery: '',
      addDrugLoading: false,
      editDrugTableForm: {
        quantity: '',
        time: '',
      },
      editDrugTableLoading: false,
      newVitalSignData: [],
      drug_scientific_name_id: null,
      is_active: false,
      // Bulk Drug Addition
      bulkDrugs: [],
      bulkDrugLoading: false,
    }
  },
  mounted() {
    // Parse is_active from route params (it comes as string)
    this.is_active = this.$route.params.is_active === 'true'
      || this.$route.params.is_active === true
    this.getVitalSigns()
    this.getDrugPrescription()
  },
  methods: {
    setVitalSignTypeValue(value) {
      this.vital_sign_type_value = {
        min: value.min_normal_value,
        max: value.max_normal_value,
      }
    },
    printPage() {
      this.$refs.html2PdfExaminationTable.generatePdf()
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      if (!date || isNaN(date)) {
        return ''
      }

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:00`
    },
    formatDateWithoutTime(unformatedDate) {
      const date = new Date(unformatedDate)

      const year = date.getFullYear()
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDate()}`

      if (month.length < 2) month = `0${month}`
      if (day.length < 2) day = `0${day}`

      // Return the formatted date string
      return `${year}-${month}-${day}`
    },
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true
        this.EditForm = {
          date: new Date().toISOString(),
          value: '',
          vital_sign_type: '',
          patient_card_id: this.$route.params.id,
          _method: 'POST',
        }
      } else {
        this.createMode = false
        this.EditForm.id = item.id
        this.EditForm.value = item.value
        this.EditForm.date = new Date(item.date).toISOString()
        this.EditForm.vital_sign_type = item.vital_sign_type
        this.EditForm.patient_card_id = item.patient_card_id
        this.EditForm._method = 'PUT'
      }
      this.$bvModal.show('modal-edit')
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode)
    },

    async getVitalSigns() {
      this.loading = true
      // check if there are any null value in the obj we sending

      let url = `/vital-signs?filter[patient_card_id]=${this.$route.params.id}&include=patientCard,vitalSignTypeData&page=${this.page}&take=${this.take}&sort=-id`

      if (this.typeFilter) {
        url += `&filter[vital_sign_type]=${this.typeFilter}`
      }
      if (this.dateFilter) {
        url += `&filter[date]=${this.formatDateWithoutTime(this.dateFilter)}`
      }
      this.fetchUrl = url
      await this.getList(url)
      this.dataCount = this.all_data.total
      this.data = this.all_data.data
      this.formatVitalSign()
      this.printData = this.data
      // this.prepareChartData(this.data);
      this.loading = false
      this.refresh = !this.refresh
    },

    deleteModel(item) {
      this.deleteForm = item
      this.$bvModal.show('modal-delete')
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/vital-signs/${this.deleteForm.id}`)
        .then(response => {
          this.getVitalSigns()

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: `deleted ${this.deleteForm.first_name} successfully`,
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.first_name}`,
            },
          })
        })
    },
    getNestedProperty(obj, path, defaultValue = 'N/A') {
      const result = path
        .split('.')
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj,
        )
      // console.log("result", result);
      return result
    },
    submitItem() {
      for (const item in this.errorForm) {
        this.errorForm[item] = ''
        if (this.EditForm[item] == '' || this.EditForm[item] == null) delete this.EditForm[item]
      }
      this.EditForm.date = this.formatDate(this.EditForm.date)
      this.EditForm.vital_sign_type = this.getNestedProperty(
        this.EditForm.vital_sign_type,
        'name',
      )
      if (this.createMode) {
        (this.params.form = this.EditForm),
        (this.params.path = '/vital-signs'),
        this.$store
          .dispatch('create', this.params)
          .then(response => {
            this.getVitalSigns()
            this.setVitalSignTypeValue({
              min_normal_value: 0,
              max_normal_value: 0,
            })
          })
          .catch(error => {
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      } else {
        (this.params.form = this.EditForm),
        (this.params.path = `/vital-signs/${this.EditForm.id}?_method=PUT`),
        this.$store
          .dispatch('update', this.params)
          .then(response => {
            this.getVitalSigns()
            this.setVitalSignTypeValue({
              min_normal_value: 0,
              max_normal_value: 0,
            })
          })
          .catch(error => {
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      }
    },

    // //////////////////////// drug prescription ////////////////////////
    async getDrugPrescription() {
      this.drugPrescriptionLoading = true
      const url = `/patientCardPrescriptions?filter[patient_card_id]=${this.$route.params.id}&include=patientCard,patientCardDrugTable,item,drugScientificName&page=${this.pageDrugPrescription}&take=${this.takeDrugPrescription}&sort=-id`
      await this.getList(url)
      this.dataCountDrugPrescription = this.all_data.total
      const copyData = this.all_data.data

      this.dataDrugPrescription = copyData
      this.drugPrescriptionLoading = false
      // console.log(this.dataDrugPrescription, 'dataDrugPrescription');
    },
    // async getAllItems() {
    //   let url = `/item?take=2000`;
    //   await this.getList(url);
    //   this.allItems = this.all_data.data;
    //   console.log(this.allItems, "allItems");
    // },
    handleSourceChange(value) {
      this.drugPrescriptionForm.item_name = ''
      this.drugPrescriptionForm.item_id = null
    },
    showDrugPrescription(item, mode) {
      if (mode === 'create') {
        this.createMode = true
        // Reset form for new entry
        this.drugPrescriptionForm = {
          item_id: null,
          item_name: '',
          number_of_doses: '',
          duration_between_doses: '',
          source_of_drug: '',
          type: '',
          dose: '',
          start_time: new Date().toISOString(),
          description: '',
          patient_card_id: this.$route.params.id,
          _method: 'POST',
        }
      } else {
        this.createMode = false
        // Fill form with existing data for edit
        this.drugPrescriptionForm = {
          id: item.id,
          item_id: item.item_id,
          item_name: item.item_name,
          number_of_doses: item.number_of_doses,
          duration_between_doses: item.duration_between_doses,
          source_of_drug: item.source_of_drug,
          type: item.type,
          dose: item.dose,
          start_time: new Date(item.start_time).toISOString(),
          description: item.description,
          patient_card_id: item.patient_card_id,
          _method: 'PUT',
        }
      }

      // Show the modal
      this.$bvModal.show('modal-drug-prescription')
    },
    submitDrugPrescription() {
      let count = 0
      this.drugPrescriptionLoading = true

      // Reset error messages
      this.errorDrugPrescriptionForm = {
        item_id: '',
        item_name: '',
        number_of_doses: '',
        duration_between_doses: '',
        source_of_drug: '',
        type: '',
        dose: '',
        start_time: '',
        description: '',
      }

      if (this.drugPrescriptionForm.source_of_drug === 'external') {
        this.drugPrescriptionForm.item_id = null
      } else {
        this.drugPrescriptionForm.item_name = ''
      }

      // Clear empty fields from form
      for (const item in this.errorDrugPrescriptionForm) {
        if (
          this.drugPrescriptionForm[item] === ''
          || this.drugPrescriptionForm[item] === null
        ) {
          delete this.drugPrescriptionForm[item]
        }
      }

      // Validate required fields
      if (!this.drugPrescriptionForm.source_of_drug) {
        count++
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Validation Error',
            variant: 'danger',
            text: 'The source of drug field is required',
          },
        })
      }

      if (this.drugPrescriptionForm.source_of_drug === 'external') {
        // For external source, only item_name is required
        if (!this.drugPrescriptionForm.item_name) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The item name field is required',
            },
          })
        }
      } else {
        // For hospital and pharmacy sources, validate all fields
        if (!this.drugPrescriptionForm.item_id) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The item field is required',
            },
          })
        }

        if (!this.drugPrescriptionForm.number_of_doses) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The number of doses field is required',
            },
          })
        }

        if (!this.drugPrescriptionForm.duration_between_doses) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The duration between doses field is required',
            },
          })
        }
      }

      if (count > 0) {
        this.drugPrescriptionLoading = false
        return false
      }

      // Format date
      if (this.drugPrescriptionForm.start_time) {
        this.drugPrescriptionForm.start_time = this.formatDate(
          this.drugPrescriptionForm.start_time,
        )
      }

      this.drugPrescriptionForm.patient_card_id = this.$route.params.id
      console.log(this.drugPrescriptionForm, 'drugPrescriptionForm')

      // Create or Update
      const params = {
        form: this.drugPrescriptionForm,
        path: this.createMode
          ? '/patientCardPrescriptions'
          : `/patientCardPrescriptions/${this.drugPrescriptionForm.id}`,
      }

      this.$store
        .dispatch(this.createMode ? 'create' : 'update', params)
        .then(response => {
          this.drugPrescriptionLoading = false
          this.$bvModal.hide('modal-drug-prescription')
          this.getDrugPrescription()

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.createMode
                ? 'Created Successfully'
                : 'Updated Successfully',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.drugPrescriptionLoading = false
          if (error.response?.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Validation Error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              })
            }
          }
        })
    },
    deleteModelDrugPrescription(item) {
      this.deleteForm = item
      this.$bvModal.show('modal-delete-drug-prescription')
    },
    deleteDrugPrescription() {
      this.drugPrescriptionLoading = true
      this.$store
        .dispatch('delete', `/patientCardPrescriptions/${this.deleteForm.id}`)
        .then(response => {
          this.getDrugPrescription()
          this.$bvModal.hide('modal-delete-drug-prescription')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: `deleted ${this.deleteForm.item_name} successfully`,
            },
          })
        })
        .catch(error => {
          this.drugPrescriptionLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.item_name}`,
            },
          })
        })
    },

    // //////////////////////// print ////////////////////////
    showAddDrugModal(item) {
      this.selectedDrug = item
      console.log(this.selectedDrug, 'selectedDrug')
      this.addDrugForm = {
        patient_card_prescription_id: item.id,
        time: new Date(item.start_time).toISOString(),
        department_id: null,
        item_id:
          item.item_id
          && (item.source_of_drug === 'hospital'
            || item.source_of_drug === 'pharmacy')
            ? item.item_id
            : null,
        quantity: '',
        time: '',
      }
      if (item.source_of_drug === 'external') {
        this.addDrugForm.item_id = null
        this.addDrugForm.item_name = item.item_name
      }
      console.log(this.addDrugForm, 'addDrugForm')
      this.$bvModal.show('modal-add-drug-to-patient')
    },
    submitAddDrugToPatient() {
      const form = {
        patient_card_prescription_id:
          this.addDrugForm.patient_card_prescription_id,
        time: this.formatDate(this.addDrugForm.time),
        department_id: this.addDrugForm.department_id,
        item_id: this.addDrugForm.item_id,
        quantity: this.addDrugForm.quantity,
      }
      // console.log(form, "form");
      // return;
      this.addDrugLoading = true
      this.$store
        .dispatch('create', {
          form,
          path: '/patientCardDrugTables',
        })
        .then(response => {
          this.addDrugLoading = false
          this.$bvModal.hide('modal-add-drug-to-patient')
          this.getDrugPrescription()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Drug Added Successfully',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.addDrugLoading = false
          if (error.response?.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Validation Error',
                  variant: 'danger',
                  text: error.response.data[item],
                },
              })
            }
          }
        })
    },
    handleDepartmentChange(value) {
      //   this.addDrugForm.item_id = null;
      //   this.departmentQuery = `filter[department_id]=${value}`;
    },
    formatDateTime(datetime) {
      if (!datetime) return ''
      const date = new Date(datetime)
      return date.toLocaleString()
    },
    editDrugTableEntry(entry) {
      this.editDrugTableForm = {
        quantity: entry.quantity,
        time: new Date(entry.time).toISOString(),
        _method: 'PUT',
      }
      console.log(entry, 'entry')
      this.selectedDrug = entry.id

      this.$bvModal.show('modal-edit-drug-table-entry')
    },
    submitEditDrugTableEntry() {
      this.editDrugTableLoading = true
      this.editDrugTableForm.time = this.formatDate(
        this.editDrugTableForm.time,
      )
      this.$store
        .dispatch('update', {
          form: this.editDrugTableForm,
          path: `/patientCardDrugTables/${this.selectedDrug}`,
        })
        .then(response => {
          this.editDrugTableLoading = false
          this.$bvModal.hide('modal-edit-drug-table-entry')
          this.getDrugPrescription()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Drug Entry Updated Successfully',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.editDrugTableLoading = false
          if (error.response?.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Validation Error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              })
            }
          }
        })
    },
    deleteDrugTableEntry(entry) {
      this.deleteForm = entry
      this.$bvModal.show('modal-delete-drug-table-entry')
    },
    submitDeleteDrugTableEntry() {
      this.drugPrescriptionLoading = true
      this.$store
        .dispatch('delete', `/patientCardDrugTables/${this.deleteForm.id}`)
        .then(response => {
          this.getDrugPrescription()
          this.$bvModal.hide('modal-delete-drug-table-entry')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: `deleted ${this.deleteForm.quantity} successfully`,
            },
          })
        })
        .catch(error => {
          this.drugPrescriptionLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.quantity}`,
            },
          })
        })
    },
    formatVitalSign() {
      // Initialize empty arrays for each vital sign type
      const temperatureVitals = []
      const pulseVitals = []

      // Sort the data into respective arrays
      this.data.forEach(item => {
        if (item.vital_sign_type === 'temperature') {
          temperatureVitals.push(item)
        } else if (item.vital_sign_type === 'pulse') {
          pulseVitals.push(item)
        }
      })

      // Sort each array by date in ascending order
      temperatureVitals.sort((a, b) => new Date(a.date) - new Date(b.date))
      pulseVitals.sort((a, b) => new Date(a.date) - new Date(b.date))

      // Format dates if needed
      temperatureVitals.forEach(item => {
        item.date = this.formatDate(item.date)
      })
      pulseVitals.forEach(item => {
        item.date = this.formatDate(item.date)
      })

      // Set the newVitalSignData with the grouped and sorted data
      this.newVitalSignData = [
        {
          type: 'temperature',
          vitals: temperatureVitals,
        },
        {
          type: 'pulse',
          vitals: pulseVitals,
        },
      ]
      console.log(this.newVitalSignData, 'newVitalSignData')
    },

    // Bulk Drug Methods
    showBulkDrugModal() {
      this.bulkDrugs = [
        {
          source_of_drug: 'external',
          item_id: null,
          item_name: '',
          number_of_doses: '',
          duration_between_doses: '',
        },
      ]
      this.$bvModal.show('modal-bulk-drug')
    },
    closeBulkDrugModal() {
      this.bulkDrugs = []
      this.$bvModal.hide('modal-bulk-drug')
    },
    addBulkDrugRow() {
      this.bulkDrugs.push({
        source_of_drug: 'external',
        item_id: null,
        item_name: '',
        number_of_doses: '',
        duration_between_doses: '',
      })
    },
    removeBulkDrug(index) {
      this.bulkDrugs.splice(index, 1)
    },
    handleBulkSourceChange(index, value) {
      if (value === 'external') {
        this.bulkDrugs[index].item_id = null
      } else {
        this.bulkDrugs[index].item_name = ''
      }
    },
    async submitBulkDrugs() {
      // Validate all drugs
      let hasError = false
      for (let i = 0; i < this.bulkDrugs.length; i++) {
        const drug = this.bulkDrugs[i]
        if (!drug.source_of_drug) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text: `${this.$t('office.drug')} ${i + 1}: ${this.$t('office.source_of_drug')} ${this.$t('validation.required')}`,
            },
          })
          hasError = true
          continue
        }

        if (drug.source_of_drug === 'external') {
          if (!drug.item_name || !drug.item_name.trim()) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: this.$t('common.error'),
                variant: 'danger',
                text: `${this.$t('office.drug')} ${i + 1}: ${this.$t('office.item_name_external')} ${this.$t('validation.required')}`,
              },
            })
            hasError = true
            continue
          }
        } else if (!drug.item_id) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text: `${this.$t('office.drug')} ${i + 1}: ${this.$t('office.item_name')} ${this.$t('validation.required')}`,
            },
          })
          hasError = true
          continue
        }

        if (!drug.number_of_doses || drug.number_of_doses <= 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text: `${this.$t('office.drug')} ${i + 1}: ${this.$t('office.number_of_doses')} ${this.$t('validation.required')}`,
            },
          })
          hasError = true
          continue
        }

        if (!drug.duration_between_doses || drug.duration_between_doses <= 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text: `${this.$t('office.drug')} ${i + 1}: ${this.$t('office.duration_between_doses')} ${this.$t('validation.required')}`,
            },
          })
          hasError = true
          continue
        }
      }

      if (hasError) {
        return
      }

      this.bulkDrugLoading = true

      try {
        // Prepare prescriptions payload
        const prescriptions = this.bulkDrugs.map(drug => {
          const prescription = {
            patient_card_id: this.$route.params.id,
            source_of_drug: drug.source_of_drug || 'external',
            number_of_doses: parseInt(drug.number_of_doses),
            duration_between_doses: parseInt(drug.duration_between_doses),
            start_time: this.formatDate(new Date().toISOString()),
          }

          if (drug.source_of_drug === 'external') {
            prescription.item_name = drug.item_name
          } else {
            prescription.item_id = drug.item_id
          }

          return prescription
        })

        const response = await this.$http.post('/patientCardPrescriptions/bulk', {
          prescriptions,
        })

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.success'),
            variant: 'success',
            text: this.$t('office.bulk-drugs-added-successfully') || 'تم إضافة الأدوية بنجاح',
          },
        })

        this.closeBulkDrugModal()
        await this.getDrugPrescription()
      } catch (error) {
        console.error('Error adding bulk drugs:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: error.response?.data?.message || this.$t('common.error-occurred'),
          },
        })
      } finally {
        this.bulkDrugLoading = false
      }
    },

    // Dose Time Calculation and Display
    getDoseTimes(drug) {
      if (!drug.start_time || !drug.number_of_doses || !drug.duration_between_doses) {
        return []
      }

      const times = []
      const startTime = new Date(drug.start_time)
      const durationHours = parseInt(drug.duration_between_doses) || 0
      const numberOfDoses = parseInt(drug.number_of_doses) || 0

      for (let i = 0; i < numberOfDoses; i++) {
        const doseTime = new Date(startTime)
        doseTime.setHours(doseTime.getHours() + (i * durationHours))
        times.push(doseTime)
      }

      return times
    },
    formatTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      let hours = d.getHours()
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const { isRTL } = this.$store.state.appConfig

      // Convert to 12-hour format
      const period = hours >= 12 ? (isRTL ? 'مساء' : 'PM') : (isRTL ? 'صباح' : 'AM')
      hours %= 12
      hours = hours === 0 ? 12 : hours // 0 should be 12

      return `${hours}:${minutes} ${period}`
    },
    isDoseTaken(drug, doseTime) {
      if (!drug.patient_card_drug_table || !Array.isArray(drug.patient_card_drug_table)) {
        return false
      }

      // Compare times more accurately (within 5 minutes tolerance)
      const doseTimeMs = new Date(doseTime).getTime()
      return drug.patient_card_drug_table.some(entry => {
        if (!entry.time) return false
        const entryTimeMs = new Date(entry.time).getTime()
        const diffMinutes = Math.abs((doseTimeMs - entryTimeMs) / (1000 * 60))
        return diffMinutes <= 5 // Consider taken if within 5 minutes
      })
    },
    async markDoseAsTaken(drug, doseTime) {
      if (!this.is_active || this.isDoseTaken(drug, doseTime)) {
        return
      }

      try {
        const form = {
          patient_card_prescription_id: drug.id,
          time: this.formatDate(doseTime.toISOString()),
          quantity: drug.dose || '1',
        }

        if (drug.item_id && (drug.source_of_drug === 'hospital' || drug.source_of_drug === 'pharmacy')) {
          form.item_id = drug.item_id
        } else if (drug.source_of_drug === 'external') {
          form.item_name = drug.item_name
        }

        this.addDrugLoading = true
        await this.$store.dispatch('create', {
          form,
          path: '/patientCardDrugTables',
        })

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.success'),
            variant: 'success',
            text: this.$t('office.dose-marked-as-taken') || 'تم تحديد الجرعة كمأخوذة',
          },
        })

        await this.getDrugPrescription()
      } catch (error) {
        console.error('Error marking dose as taken:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: error.response?.data?.message || this.$t('common.error-occurred'),
          },
        })
      } finally {
        this.addDrugLoading = false
      }
    },
  },
}
</script>
<style scoped>
/* CSS */

.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.chart {
  page-break-inside: avoid;
}

/* Bulk Drug Table Styles */
.bulk-drug-table-container {
  overflow-x: auto;
  margin-top: 1rem;
}

.bulk-drug-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.bulk-drug-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}

.bulk-drug-table tbody tr:last-child {
  border-bottom: none;
}

.drug-row {
  transition: background-color 0.2s ease;
}

.drug-row:hover {
  background-color: #f8f9fa;
}

.drug-name-cell {
  padding: 1rem;
  font-weight: 600;
  background-color: #f8f9fa;
  border-right: 2px solid #dee2e6;
  min-width: 200px;
  position: sticky;
  left: 0;
  z-index: 1;
}

.drug-name-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dose-time-cell {
  padding: 0.75rem 1rem;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  min-width: 120px;
  cursor: default;
}

.dose-time-cell.dose-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.dose-time-cell.dose-clickable:hover {
  background-color: #e3f2fd;
  transform: scale(1.05);
}

.dose-time-cell.dose-taken {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.dose-time-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.dose-time-content .text-decoration-line-through {
  text-decoration: line-through;
}
</style>

<style>
/* Dark Mode Styles for Bulk Drug Table */
body.dark-layout .bulk-drug-table {
  background-color: #1e2532;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  border: 1px solid #4a5568;
}

body.dark-layout .bulk-drug-table tbody tr {
  border-bottom: 2px solid #4a5568;
}

body.dark-layout .drug-row:hover {
  background-color: #2d3748;
}

body.dark-layout .drug-name-cell {
  background-color: #2d3748;
  border-right: 3px solid #4a5568;
  color: #e2e8f0;
  font-weight: 700;
}

body.dark-layout .drug-name-cell strong {
  color: #f7fafc;
}

body.dark-layout .dose-time-cell {
  border-right: 2px solid #4a5568;
  color: #e2e8f0;
  font-weight: 500;
}

body.dark-layout .dose-time-cell.dose-clickable {
  background-color: #2d3748;
}

body.dark-layout .dose-time-cell.dose-clickable:hover {
  background-color: #3182ce;
  color: #ffffff;
  border-color: #63b3ed;
}

body.dark-layout .dose-time-cell.dose-taken {
  background-color: #276749;
  color: #9ae6b4;
  border-color: #48bb78;
}

body.dark-layout .dose-time-cell.dose-taken .text-success {
  color: #68d391 !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
